import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { isFormSubmitted } from "../../../common/utilities/FormsHelper";
import { MerchantApi } from "../../../common/apis/merchant-api";
import { InputType } from "../../../common/components/input/enum/InputType";
import { ErrorHandling } from "../../../common/classes/ErrorHandling";
import { AppNavigator, NavigatorTarget } from "../../../services/app-navigator";
import { ValidationErrorType } from "../../../common/enums/ValidationErrorType";
import { Router } from "@angular/router";
import { EmailApi } from "../../../common/apis/email-api";
import { MerchantLoginService } from "../../../common/services/merchant-login.service";
import { JWTToken } from "../../../common/interfaces/JWTToken";

@Component({
  selector: 'app-merchant-login',
  templateUrl: './merchant-login.component.html',
  styleUrls: ['./merchant-login.component.scss']
})
export class MerchantLoginComponent {
  public showPasswordFieldText = false;
  public signInForm: FormGroup = new FormGroup({});

  serverError: string | null = null
  isLoading = false;

  errorHandling: ErrorHandling | null = null;

  InputType = InputType;
  Validators = Validators

  inputEmail = ''
  inputPassword = ''

  emailLabel: string = $localize`:@@emailLabel:Email`;
  passwordLabel: string = $localize`:@@passwordLabel:Password`;
  loginLabel: string = $localize`:@@login:Login`;

  constructor(private formBuilder: FormBuilder,
              private merchantApi: MerchantApi,
              private appNavigator: AppNavigator,
              private router: Router,
              private emailApi: EmailApi,
              private merchantLoginService: MerchantLoginService) {
  }

  ngOnInit() {
  }

  togglePasswordShowButtonClicked() {
    this.showPasswordFieldText = !this.showPasswordFieldText;
  }


  updateInputFieldById(id: string, value: any) {
    if (id == "email") {
      this.inputEmail = value;
    } else if (id == "password") {
      this.inputPassword = value;
    }
  }

  onForgotPassword() {
    this.appNavigator.navigateTo({ target: NavigatorTarget.merchantForgotPassword })
  }

  onLoginSubmitted() {
    if (isFormSubmitted(this.signInForm)) {
      let email = this.inputEmail;
      let password = this.inputPassword;
      this.isLoading = true;
      this.merchantApi.merchantLogin(email, password).subscribe({
        next: (result: JWTToken) => {
          console.log("Logged in successfully")
          this.merchantLoginService.redirectToLogin(result);
          this.isLoading = false;
        },
        error: error => {
          this.isLoading = false;
          if(error === ValidationErrorType.emailNotVerified){
            this.navigateToVerifyEmail();
          } else {
            if(error === ValidationErrorType.UNAUTHORIZED)
              this.serverError = $localize`Incorrect username and/or password.`
            else
              this.serverError = $localize`Something went wrong. Please try again later or contact support.`
          }
        }
      })
    }
  }



  navigateToVerifyEmail(){
    let email = this.inputEmail;
    this.emailApi.resendVerificationEmail(email).subscribe({
      next: (result) => {
        this.isLoading = false;
        this.router.navigate(["/merchants/email-confirmation"])
      },
      error: error => {
        this.router.navigate(["/merchants/email-confirmation"])
        this.isLoading = false;
        // this.serverError = error
      }
    })
  }

}
